import moment from 'moment'

export const monthsEmployed = (date1, date2) => {
  const employmentDate = moment(date1, 'YYYY-MM-DD')
  const leaveDate = moment(date2, 'YYYY-MM-DD')
  const days = moment.duration(leaveDate.diff(employmentDate)).asMonths()
  return days
}
